import React, { FC } from 'react';
import { useTableLegends } from '../../../contexts/table/LegendContext';
import { TableLegendItem } from '../../../models/table/TableLegendItem';
import CheckboxField from '../../checkbox-list-field/checkboxField';

const TableLegend: FC = () => {
    // replicating title and status to label and value, and adding isSelected for checkbox functionality.
    const legendContext = useTableLegends();

    return <>
        {legendContext.legendItems.length > 0 ?
            <div className={"flex flex-col flex-grow my-2 w-26"}>
                <div className={"object-right flex flex-row-reverse"} >
                    <div className="row gap-3 flex justify-between ">
                        {legendContext.legendItems.map((item, i) => {
                            return (
                                <div key={`tableLegend_${i}`} className="flex space-x-1 ">
                                    {legendContext.tableLegendSelectable ?
                                        <span className="text-xs">
                                            <CheckboxField
                                                onSelect={(_, option: TableLegendItem) => legendContext.onLegendFilterChange(option)}
                                                option={item}
                                                image={item.imageIcon}
                                                compact></CheckboxField>
                                        </span>
                                        : <>
                                            <img src={item.imageIcon} title={item.tooltip} className=" w-5" alt="" />
                                            <p className="text-xs ml-8..."> {item.label} </p>
                                        </>}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
            : null}
    </>
}

export default TableLegend;
